module.exports = __webpack_public_path__ + "static/cherrylimeade-91fdb1af42d0fff8a7f6263cb1dcdbf3.jpg";